<template>
  <v-select
    v-model="internalValue"
    :items="items"
    :placeholder="placeholder || 'Seleccione un Origen'"
    label="Origen de la Cotización"
    :loading="loading"
    :prepend-inner-icon="icon || 'fas fa-map-marker-alt'"
    item-value="id"
    item-text="name"
    outlined
    dense
    hide-details="auto"
    class="modern-select rounded-lg"
    :error-messages="errors"
    return-object
    :disabled="disabled"
    @input="updateValue"
    @change="change"
  >
    <template v-slot:item="{ item }">
      <div class="d-flex align-center py-2">
        <v-avatar size="24" color="blue lighten-5" class="mr-3">
          <v-icon x-small color="blue darken-1">{{ item.id === '' ? 'fas fa-list' : 'fas fa-map-pin' }}</v-icon>
        </v-avatar>
        <div class="body-2 font-weight-medium grey--text text--darken-4">{{ item.name }}</div>
      </div>
    </template>

    <template v-slot:selection="{ item }">
      <div class="d-flex align-center">
        <span class="body-2 font-weight-black primary--text">{{ item.name }}</span>
      </div>
    </template>
  </v-select>
</template>

<script>
export default {
  name: 'OriginSelection',
  props: {
    value: {
      type: [Object, String, Number],
      default: () => ({ id: '' })
    },
    errors: {
      type: Array,
      default: () => []
    },
    icon: {
      type: String,
      default: ''
    },
    loading: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    filtro: {
      type: Boolean,
      default: false
    },
    placeholder: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      internalValue: null
    }
  },
  computed: {
    items() {
      const origins = this.$store.state.origins || []
      if (this.filtro) {
        return [{ name: 'Todos los Orígenes', id: '' }, ...origins]
      }
      return origins
    }
  },
  watch: {
    value: {
      handler(val) {
        // Handle both object and primitive cases from parent
        if (typeof val === 'object' && val !== null) {
          this.internalValue = val
        } else {
          // If parent sends ID, find object in items
          this.internalValue = this.items.find(i => i.id === val) || { id: '', name: '' }
        }
      },
      immediate: true
    }
  },
  methods: {
    updateValue(val) {
      const emitVal = val ? val.id : ''
      this.$emit('input', emitVal)
    },
    change(val) {
      const emitVal = val ? val.id : ''
      this.$emit('change', emitVal)
    }
  }
}
</script>

<style scoped>
.modern-select >>> .v-input__control { min-height: 44px !important; }
.modern-select >>> fieldset { border: 1px solid rgba(0,0,0,0.08) !important; border-radius: 8px !important; transition: all 0.3s ease; }
.modern-select >>> .v-select__selection { font-family: 'Outfit', sans-serif !important; }
.modern-select >>> .v-label { font-size: 0.85rem !important; font-weight: 600 !important; color: #64748b !important; }

/* Focus styles */
.modern-select.v-input--is-focused >>> fieldset { border: 2px solid var(--v-primary-base) !important; }
</style>